@if (formControl()) {
<div class="color form-group">
  <mat-form-field class="form-field">
    <div matPrefix class="color-view" [style.backgroundColor]="formControl()?.value"></div>
    <input class="input-color" matInput [placeholder]="meta().name" [formControl]="formControl()!" [readonly]="readonly()">
    @if (formControl()?.value && !readonly()) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="formControl()?.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-hint><strong>{{meta().info}}</strong></mat-hint>
    @if (formControl()?.hasError('required')) {
      <mat-error>
        {{meta().name}} is <strong>required</strong>
      </mat-error>
    }
    @if (formControl()?.hasError('form')) {
      <mat-error>
        {{formError}}
      </mat-error>
    }
  </mat-form-field>
</div>
}
